export default __webpack_public_path__ + "static/Proof-of-Concept-e9f1659c483a14cd87e1ec308fa04cfe.webp";